import { render } from "./PHP.vue?vue&type=template&id=c7f018fe&scoped=true"
import script from "./PHP.vue?vue&type=script&lang=js"
export * from "./PHP.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-c7f018fe"

export default script